import './loader.css';

function Loader() {
  return (
    <div className="loader-container">
      <span className="loader" />
    </div>
  );
}

export default Loader;
